import { render, staticRenderFns } from "./ComponentHeader.vue?vue&type=template&id=08567f5f&scoped=true"
import script from "./ComponentHeader.vue?vue&type=script&lang=js"
export * from "./ComponentHeader.vue?vue&type=script&lang=js"
import style0 from "./ComponentHeader.vue?vue&type=style&index=0&id=08567f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08567f5f",
  null
  
)

export default component.exports